import { initialsOf } from '@/pages/CareCoordination/CareJourneys/journeyTheme'

/**
 * Flat initials disc from the board design. Two tints so a row's two people —
 * the coordinator working it and the patient it is about — never read as the
 * same person at a glance.
 */
const TINT = {
  person: { bg: '#edf1f6', fg: '#59657a' },
  patient: { bg: '#e8eef8', fg: '#3f5878' },
} as const

export const InitialsAvatar = ({
  name,
  tone,
  size = 26,
}: {
  name: string
  tone: keyof typeof TINT
  size?: number
}) => {
  const { bg, fg } = TINT[tone]
  return (
    <span
      aria-hidden
      className="flex shrink-0 items-center justify-center rounded-full font-semibold"
      style={{
        width: size,
        height: size,
        background: bg,
        color: fg,
        fontSize: size <= 22 ? 9.5 : 10.5,
      }}
    >
      {initialsOf(name)}
    </span>
  )
}
